// extracted by mini-css-extract-plugin
module.exports = {"HeaderLogo":"HeaderLogo_HeaderLogo__3jGMq","text":"HeaderLogo_text__10gIW","full":"HeaderLogo_full__31Rmi","min":"HeaderLogo_min__7t3mi","logo":"HeaderLogo_logo__1hsDC"};